<!-- =========================================================================================
  File Name: TheNavbar.vue
  Description: Navbar component
  Component Name: TheNavbar
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div class="relative the-nav-bar">

    <div class="vx-navbar-wrapper" :class="classObj">

      <vs-navbar class="vx-navbar navbar-custom navbar-skelton" :color="navbarColorLocal" :class="textColor">

        <!-- SM - OPEN SIDEBAR BUTTON -->
        <feather-icon class="sm:inline-flex xl:hidden cursor-pointer p-2" icon="MenuIcon" @click.stop="showSidebar" />

<!--        <bookmarks :navbarColor="navbarColor" v-if="windowWidth >= 992" />-->
        <span
          v-if="!isSpecial"
          class="page-title">{{pageTitle}}</span>
        <div
          v-if="isSpecial"
          class="flex special-page-title"
        >
          <span class="alias">{{alias || login}}</span>
          <div
            v-if="!realMobile"
            :style="themeOpacty"
            class="tag-box tag hidden-xs-only">
            {{specialText}}
          </div>
        </div>
        <vs-spacer />
        <!-- <div
          @click="toNewUIHandle"
          class="toggle-ui">{{$t('Return_to_old_version')}} <i class="el-icon-arrow-right"></i></div> -->
        <i18n class=""></i18n>
<!--        <search-bar />-->

<!--        <notification-drop-down />-->

        <profile-drop-down />

      </vs-navbar>
    </div>

    <!--              MAM 主账户需要另外显示的逻辑, 需要显示 mt4别名没有别名就显示login 以及tag标签, MAM主-->
<!--    <div

      class="router-header flex flex-wrap items-center mb-6"
    >

    </div>-->

  </div>
</template>


<script>

import { getTraderOverview } from '@/api/copy'
import { colorRgba } from '@/utils/index.js';
import { mapGetters } from 'vuex'
import i18n            from "./components/I18n.vue"
// import Bookmarks            from "./components/Bookmarks.vue"
import SearchBar            from "./components/SearchBar.vue"
import NotificationDropDown from "./components/NotificationDropDown.vue"
import ProfileDropDown      from "./components/ProfileDropDown.vue"

export default {
  name: "the-navbar-vertical",
  props: {
    navbarColor: {
      type: String,
      default: "#fff",
    },
  },
  components: {
    // Bookmarks,
    SearchBar,
    NotificationDropDown,
    ProfileDropDown,
    i18n,

  },
  data() {
    return {
      alias: '',
      login: '',
    }
  },
  watch: {
    '$route'(val){

      if(this.isSpecial){
        this.queryMtInfo();
      }
    },
  },
  computed: {
    ...mapGetters(['language','themeColor','realMobile','userInfo']),
    themeOpacty(){
      return {
        background: colorRgba(this.themeColor,0.1),
        color: this.themeColor,
      }
    },
    isSpecial(){
      return this.$route.path.includes('mamMasterDetails') || this.$route.path.includes('mamSubDetails');
    },
    specialText(){
      if(this.$route.path.includes('mamMasterDetails')){
        return this.$t('customerHome.MAM_master');
      }else {
        return this.$t('MAM_Investor');
      }
    },
    pageTitle(){
      return this.$route.meta.title;
    },
    navbarColorLocal() {
      return this.$store.getters.theme === "dark" && this.navbarColor === "#fff" ? "#10163a" : this.navbarColor
    },
    verticalNavMenuWidth() {
      return this.$store.getters.verticalNavMenuWidth
    },
    textColor() {
      return {'text-white': (this.navbarColor != '#10163a' && this.$store.getters.theme === 'dark') || (this.navbarColor != '#fff' && this.$store.getters.theme !== 'dark')}
    },
    windowWidth() {
      return this.$store.getters.windowWidth
    },

    // NAVBAR STYLE
    classObj() {
      if (this.verticalNavMenuWidth == "default")      return "navbar-default"
      else if (this.verticalNavMenuWidth == "reduced") return "navbar-reduced"
      else if (this.verticalNavMenuWidth)              return "navbar-full"
    },
  },
  created(){
    if(this.$route.params.mtid){
      this.queryMtInfo();
    }
  },
  methods: {
    toNewUIHandle(){
      window.open(location.origin + '/web','_self');
    },
    queryMtInfo(){
      getTraderOverview({
        mtId: this.$route.params.mtid,
      }).then((res) => {
        this.$emit('send-overview-info',res.data);
        this.alias = res.data.alias;
        this.login = res.data.login;
      });
    },
    showSidebar() {
      this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', true);
    }
  }
}
</script>
<style lang="scss" scoped>
  .page-title,
  .alias {
    font-size: 14px;
    color: #5E5873;
    font-weight: bold;
  }

  .special-page-title {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    .alias {
      padding-right: 8px;
    }
  }

  .toggle-ui {
    display: inline-block;
    cursor: pointer;
    height: 18px;
    line-height: 18px;
    text-align: center;
    padding: 0 10px;
    margin-right: 10px;
    background-color: rgba(246, 246, 246, 1);
    border-radius: 5px;
    color: #626262;
  }
</style>
